/**
 * contains the abi and contract address
*/

class ProjectMetadata {
    constructor() {
        this.abi = [
	{
		"inputs": [
			{
				"internalType": "bytes32",
				"name": "projectHash",
				"type": "bytes32"
			},
			{
				"internalType": "int16",
				"name": "bpm",
				"type": "int16"
			},
			{
				"internalType": "bytes32",
				"name": "thumbnail",
				"type": "bytes32"
			},
			{
				"internalType": "bytes32[]",
				"name": "presetHash",
				"type": "bytes32[]"
			},
			{
				"internalType": "int8",
				"name": "patterns",
				"type": "int8"
			},
			{
				"internalType": "bool",
				"name": "hasArrangement",
				"type": "bool"
			}
		],
		"name": "newProjectMetadata",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [],
		"stateMutability": "nonpayable",
		"type": "constructor"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": false,
				"internalType": "bytes32",
				"name": "projectHash",
				"type": "bytes32"
			},
			{
				"indexed": false,
				"internalType": "int16",
				"name": "bpm",
				"type": "int16"
			}
		],
		"name": "ProjectBPM",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": false,
				"internalType": "bytes32",
				"name": "projectHash",
				"type": "bytes32"
			}
		],
		"name": "ProjectHasArrangement",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": false,
				"internalType": "bytes32",
				"name": "projectHash",
				"type": "bytes32"
			},
			{
				"indexed": false,
				"internalType": "int8",
				"name": "patterns",
				"type": "int8"
			}
		],
		"name": "ProjectPatternsCount",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": false,
				"internalType": "bytes32",
				"name": "projectHash",
				"type": "bytes32"
			},
			{
				"indexed": false,
				"internalType": "bytes32",
				"name": "presetHash",
				"type": "bytes32"
			}
		],
		"name": "ProjectUsesPreset",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": false,
				"internalType": "bytes32",
				"name": "projectHash",
				"type": "bytes32"
			},
			{
				"indexed": false,
				"internalType": "bytes32",
				"name": "thumbnailHash",
				"type": "bytes32"
			}
		],
		"name": "ProjectVisuals",
		"type": "event"
	}
        ];

        this.contractAddress = '0x020c2D741a221bBADc2d979b62D11e968da3450e';
    }

    getContract(web3) {
        return new web3.eth.Contract(this.abi, this.contractAddress);
    }
}

export default ProjectMetadata;
